const Divider = ({ height = 12, backgroundColor = "#F9F9F9" }) => {
    return (
        <div
            className="divider"
            style={{
                height: height,
                backgroundColor: backgroundColor,
                width: "100%",
                margin: "28px 0",
            }}
        ></div>
    );
};

export default Divider;
